import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_TO_COURSE_ENROLLMENTS_STATE } from "./consts";
import courseEnrollmentsReducer from "./reducers";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TO_COURSE_ENROLLMENTS_STATE, builder => {
  builder.register(PATH_TO_COURSE_ENROLLMENTS_STATE, courseEnrollmentsReducer);
  import("../analytics");
});

// reducer
// actions
export {
  deleteCourseEnrollment,
  receiveCourseEnrollments,
  saveNewCourseEnrollment
} from "./actions";
export {
  createCourseEnrollmentActionFactory,
  deleteCourseEnrollmentActionFactory,
  fetchAllCourseEnrollmentsActionFactory
} from "./actions/meta";
// models
export { default as CourseEnrollment } from "./models/CourseEnrollment";
// selectors
export {
  getEnrolledCourseIds,
  getEnrolledCourses,
  getMostRecentlyEnrolledCourseId,
  getNumberOfEnrolledCourses,
  isEnrolledInCourse
} from "./selectors";
export {
  courseEnrollmentCreateHasFinished,
  courseEnrollmentIsCreating,
  courseEnrollmentIsDeleting,
  courseEnrollmentsHaveFinishedFetching,
  getCourseEnrollmentCreateError,
  getCourseEnrollmentCreateErrorMessage,
  getCourseEnrollmentCreateSuccess,
  getFetchCourseEnrollmentsError,
  getFetchCourseEnrollmentsFinished,
  getFetchCourseEnrollmentsStarted,
  getFetchCourseEnrollmentsSuccess
} from "./selectors/meta";
export { courseEnrollmentsReducer, PATH_TO_COURSE_ENROLLMENTS_STATE };
